var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "m9.763 1.95 2-1.111a6.67 6.67 0 0 1 6.475 0l8.333 4.63q.456.254.86.57l-5.723 3.386zM7.56 3.174 3.43 5.469a6.7 6.7 0 0 0-1.156.812l.006.003 9.956 5.601a5.42 5.42 0 0 0 5.443-.076l.007-.004 1.6-.947-11.2-7.008a1.25 1.25 0 0 1-.526-.676M.75 8.224A6.66 6.66 0 0 0 0 11.296v7.155a6.67 6.67 0 0 0 3.429 5.828l8.333 4.63a6.7 6.7 0 0 0 2 .722 1 1 0 0 1-.012-.174V14.998a7.9 7.9 0 0 1-2.74-.934l-9.956-5.6a1.3 1.3 0 0 1-.304-.24M16.25 14.963v14.494q0 .09-.012.174a6.7 6.7 0 0 0 2-.723l8.333-4.63A6.67 6.67 0 0 0 30 18.452v-7.155c0-1.198-.321-2.35-.903-3.35a1 1 0 0 1-.127.087l-10.005 5.92-.003.002a7.9 7.9 0 0 1-2.712 1.008"
  })));
};
export default SvgPackage;